(function () {
  console.log('[CFS] mega hover v3 loaded');

  const mq = window.matchMedia('(min-width: 990px)');

  const GAP_Y = 10;
  const EDGE_PAD = 12;
  const MIN_W = 220;
  const MAX_W = 360;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function normalizeUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.replace(/\/$/, '') || '/';
    } catch (e) {
      return (url || '').replace(/\/$/, '');
    }
  }

  function dedupeParentChild(nav) {
    nav.querySelectorAll('details.mega-menu').forEach((d) => {
      const parentLink = d.querySelector('summary a.header__menu-link');
      const panel = d.querySelector('.mega-menu__content');
      if (!parentLink || !panel) return;

      const parentPath = normalizeUrl(parentLink.getAttribute('href'));
      const childLinks = Array.from(panel.querySelectorAll('a.mega-menu__link--level-2[href]'));

      childLinks.forEach((a) => {
        const childPath = normalizeUrl(a.getAttribute('href'));
        if (childPath === parentPath) {
          const li = a.closest('li');
          if (li) li.style.display = 'none';
          else a.style.display = 'none';
        }
      });
    });
  }

  function isSmallMenu(panel) {
    // “Small” = acts like a dropdown under the parent
    const links = panel.querySelectorAll('a.mega-menu__link--level-2');
    return links.length > 0 && links.length <= 6;
  }

  function positionUnderSummary(detailsEl) {
    const summary = detailsEl.querySelector('summary');
    const panel = detailsEl.querySelector('.mega-menu__content');
    if (!summary || !panel) return;
    if (!isSmallMenu(panel)) return;

    panel.classList.add('cfs-condensed-dropdown');

    // Force it into dropdown mode regardless of theme CSS
    panel.style.setProperty('position', 'fixed', 'important');
    panel.style.setProperty('transform', 'none', 'important');
    panel.style.setProperty('right', 'auto', 'important');

    // Make it measurable
    panel.style.visibility = 'hidden';
    panel.style.display = 'block';

    // Width based on content, clamped
    const contentW = Math.ceil(panel.scrollWidth);
    const targetW = clamp(contentW, MIN_W, MAX_W);
    panel.style.setProperty('width', `${targetW}px`, 'important');
    panel.style.setProperty('max-width', `${targetW}px`, 'important');

    const s = summary.getBoundingClientRect();
    const p = panel.getBoundingClientRect();
    const vw = window.innerWidth;

    // Center under summary, clamp to viewport
    let left = Math.round(s.left + (s.width / 2) - (p.width / 2));
    left = clamp(left, EDGE_PAD, vw - p.width - EDGE_PAD);

    const top = Math.round(s.bottom + GAP_Y);

    panel.style.setProperty('left', `${left}px`, 'important');
    panel.style.setProperty('top', `${top}px`, 'important');

    panel.style.visibility = 'visible';
  }

  function setupDesktop(nav) {
    if (!mq.matches) return () => {};

    dedupeParentChild(nav);

    const menus = Array.from(nav.querySelectorAll('details.mega-menu'));
    if (!menus.length) return () => {};

    const closeAll = (except) => menus.forEach((d) => { if (d !== except) d.removeAttribute('open'); });

    const cleanups = [];

    menus.forEach((d) => {
      const panel = d.querySelector('.mega-menu__content');
      if (!panel) return;

      let t;

      const open = () => {
        if (!mq.matches) return;
        clearTimeout(t);
        closeAll(d);
        d.setAttribute('open', '');

        requestAnimationFrame(() => positionUnderSummary(d));
      };

      const close = () => {
        if (!mq.matches) return;
        clearTimeout(t);
        t = setTimeout(() => d.removeAttribute('open'), 180);
      };

      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', close);
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', close);

      cleanups.push(() => {
        d.removeEventListener('mouseenter', open);
        d.removeEventListener('mouseleave', close);
        panel.removeEventListener('mouseenter', open);
        panel.removeEventListener('mouseleave', close);
      });
    });

    const onReflow = () => {
      if (!mq.matches) return;
      const openOne = menus.find((d) => d.hasAttribute('open'));
      if (openOne) positionUnderSummary(openOne);
    };
    window.addEventListener('resize', onReflow);
    window.addEventListener('scroll', onReflow, true);

    cleanups.push(() => {
      window.removeEventListener('resize', onReflow);
      window.removeEventListener('scroll', onReflow, true);
    });

    return () => cleanups.forEach((fn) => fn());
  }

  let cleanup = () => {};

  function apply() {
    cleanup();
    const nav = document.querySelector('nav.header__inline-menu');
    if (!nav) return;
    cleanup = setupDesktop(nav) || (() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
})();